import React, { forwardRef, useEffect, useState } from "react"

import styles from './motion_screen.module.css';

const MotionScreen = forwardRef((props, ref) => {
    const [video, setVideo] = useState(null);
    useEffect(() => {
        console.log('loading video')
        setVideo(
            <video
                autoPlay
                muted
                loop
                playsInline
                disablePictureInPicture
                poster="./images/main_fullscreen/preloading.jpg"
            >
                <source
                    src="./images/fullscreen.mp4"
                    type="video/mp4"
                />
                <img src="./images/main_fullscreen/preloading.jpg" alt="" />
            </video>
        )
    }, [])
    if (!video) {
        return null
    }
    return (
        <figure className={styles.figure} ref={ref}>
            {video ? video : null}
            <article className={styles.txt}>
                <div className={styles.web_txt}>
                    <p>Jsoftware</p>
                    <p>Create a smart planet with code</p>
                </div>
                <div className={styles.phone_txt}>
                    <p><strong>제이소프트웨어</strong>는</p>
                    <p>지구상 가장 똑똑한 서비스를</p>
                    <p>만듭니다</p>
                </div>
            </article>
        </figure>
    )
});

export default React.memo(MotionScreen);